export default __webpack_public_path__ + "assets/media/favicon128.5af551848f955874dd61bd02b7793de3.png";